import React from "react";

import Link from 'src/components/link';
import ImageV2 from 'src/components/image/image.v2';
import { stripHtml } from 'src/utils/string';

type EntryCardProps = {
    title: string;
    link: string;
    image: string;
    imageAlt?: string;

    tags?: React.ReactNode;
    date?: string;
    description?: string;
}

export default class EntryCard extends React.PureComponent<EntryCardProps> {
    render() {
        return <>
        <Link href={this.props.link} className="w-full max-w-full flex flex-col col-span-12 md:col-span-6 lg:col-span-4 entry-card">
            <ImageV2 useImageKit={true} width={420} className="aspect-[16/9]" style={{backgroundColor: '#EEE', minHeight: '240px', width: '100%'}} src={this.props.image} alt={this.props.imageAlt || this.props.title || ""} />
            <div className="entry-content px-0 pb-2 mb-8 bg-white">
                {this.props.tags}
                {this.props.date ? <div className="caption mb-1"> {this.props.date} </div> : null}
                <h4 className="headline3 line-clamp-2"> {this.props.title} </h4>
                {this.props.description ? <div className="line-clamp-2">{stripHtml(this.props.description)}</div> : null }
            </div>
        </Link>
        </>;
    }
}